import dayjs from 'dayjs';
import Model from '../models/model';
import consts from '../consts';
import util from '../util';
import { dataStore } from '../Store';
import { MonitoringStatusCell } from './CycleTable';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}

const { renderBIResultIcon, renderCIResultIcon, renderBICIEditButton, renderAttachmentButton } = util;

const checkIsParametric = () => isparametric()
const checkIsNotParametric = () => !isparametric()

const model = new Model({
	name: 'SterilizerCycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	title: "Sterilizer Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: "CycleName", width: 200 },
		{ field: 'CycleCount', header: "CycleCount", width: 150, align:'right', headerAlign:'right'  },
		{ field: 'CycleStatus', header: "SterCycleStatus", width: 200 },
		{ field: 'CycleStart', header: 'CycleStartDateTime', type: 'dateTime', width: 200 },
		{ field: 'MonitoringStatus', header: "ProcessMonitoring", align: 'center', width: 200, renderCell: MonitoringStatusCell, isNotExportField: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'OperatorName', header: "OperatorName", width: 200, renderCell: ({ row }) => (renderBICIEditButton(row)), align: 'right' },
		{ field: 'LoadNumber', header: "Load", width: 150},
		{ field: 'BIResult', header: 'BIResult', width: 120, type: 'int', renderCell: ({ row }) => (renderBIResultIcon(row)), excludeOnGrid: checkIsParametric, isNotExportField: true, align:'right', headerAlign:'right'  },
		{ field: 'CIResult', header: 'CIResult', width: 85, type: 'int', renderCell: ({ row }) => (renderCIResultIcon(row, 'CIResultIcon')), excludeOnGrid: checkIsParametric, isNotExportField: true, align:'right', headerAlign:'right'  },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row, true)), filterable: false, isNotExportField: true },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 150 },
		{ field: 'ReviewStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewedDate', header: "ApprovedOn", width: 150, type: 'dateTime', isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewedBy', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});

export const StreamSterilizerTabel = model;
export default model.createFormBase();
